"use client";
import { PrimaryButton } from "@/components/button/primaryButton";
import { Merchant } from "@/dto/merchant";
import { useTranslations } from "next-intl";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";

interface IButton {
  merchant: Merchant;
  checkoutDisabled: boolean;
  merchantColor: string;
  handleAddGiftCard: () => void;
}

export const AddGiftCardButton = ({
  merchant,
  checkoutDisabled,
  merchantColor,
  handleAddGiftCard,
}: IButton) => {
  const t = useTranslations("AddGiftCardButton");
  return (
    <div data-testid={applyDataTestId(pom.giftCard.addGiftCardButton)}>
      <PrimaryButton
        style={{
          backgroundColor: checkoutDisabled ? "#C7C7C7" : merchantColor,
          color: checkoutDisabled ? "#FFFFFF" : undefined,
        }}
        className="bg-black text-white clover-button-primary font-bold py-2 rounded-md w-full h-14 disabled:bg-[#C7C7C7] sm:mt-8"
        onClick={handleAddGiftCard}
        disabled={checkoutDisabled}
      >
        <span className="text-lg font-normal">
          {merchant?.services?.length !== 0 && !merchant.isEssentialMerchant
            ? t("addToCart")
            : t("buyGiftCard")}
        </span>
      </PrimaryButton>
    </div>
  );
};
